/* eslint-disable max-len */
import { FunctionComponent as F } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import profileGif from '../../images/profile.gif';
import Subtitle from '../../components/UI/Text/Subtitle';
import ArticleText from '../../components/UI/Text/ArticleText';

const Software: F = () =>
{
  return (
    <Stack spacing={2}>


    </Stack>);
};

export default Software;
